import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EmergencyBar from "@/components/EmergencyBar";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Towing from "@/components/Towing";
import Gallery from "@/components/Gallery";
import Manifesto from "@/components/Manifesto";
import Testimonials from "@/components/Testimonials";
import RequestForm from "@/components/RequestForm";
import Location from "@/components/Location";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ anchors: true, lerp: 0.09 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain-overlay bg-carbon min-h-screen" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <EmergencyBar />
        <Marquee />
        <Services />
        <Towing />
        <Gallery />
        <Manifesto />
        <Testimonials />
        <RequestForm />
        <Location />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
